/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function FlowWrench(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'FlowWrench',
      'aria-hidden': true,
      focusable: false,
      width:  12 * scale,
      height: 12 * scale,
      viewBox: '0 0 12 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fillRule":"evenodd","clipRule":"evenodd","d":"M2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm6.03 6 1.84-1.843c.077.263.13.533.13.823a2.98 2.98 0 0 1-2.981 2.975c-.38 0-.745-.08-1.08-.21l-.386.285L3.46 9.885 2.074 8.498 4.25 6.045a3 3 0 0 1-.206-1.065A2.98 2.98 0 0 1 7.02 2c.28.004.558.048.825.131l-1.843 1.84a.72.72 0 0 0 0 1.013L7.015 6A.717.717 0 0 0 8.03 6","fill":"currentColor"}))
}
